var map = {
	"./en/1-9/1_9_text.png": 68849,
	"./fi/1-9/1_9_text.png": 92163,
	"./in/1-9/1_9_text.png": 13821,
	"./th/1-9/1_9_text.png": 77866,
	"./tw/1-9/1_9_text.png": 64407,
	"./zh/1-9/1_9_text.png": 31500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50271;